module.exports = __webpack_public_path__ + "img/pick4.376bc962.png";